import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Formik } from 'formik';

import {
  LEAD_STATUS_LIST,
  LEAD_STATUS_LEASE_SIGNED,
  getLeadStatusLabel,
} from 'common/leadConstants';
import {
  APARTMENT_LOCATOR_LEADS_SORT_BY_MOVE_DATE,
  APARTMENT_LOCATOR_LEADS_SORT_BY_LEASE_START_DATE,
} from 'common/apartmentLocatorHelpers';
import extractPhoneFromText from 'common/util/extractPhoneFromText';

import H1 from 'client/components/H1';
import SrLink from 'client/components/SrLink/SrLink';
import SrFormikField from 'client/components/SrFormikField';

import ApartmentLocatorActions from 'client/actions/ApartmentLocator';
import branch from 'client/core/branch';

@branch({
  leadsUpdated: ['apartmentLocator', 'leadsUpdated'],
})
class SrAgentLeadsHeader extends Component {
  static propTypes = {
    sortCriteria: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    leadStatus: PropTypes.oneOf(LEAD_STATUS_LIST).isRequired,
    onSearchText: PropTypes.func.isRequired,
    leadsUpdated: PropTypes.object.isRequired,
    onToggleSortCriteriaModal: PropTypes.func.isRequired,
    onUpdateSortCriteria: PropTypes.func.isRequired,
  };

  _onClick = ({ newLeadStatusOption }) => {
    const { dispatch, leadStatus, sortCriteria, onUpdateSortCriteria } = this.props;
    if (
      newLeadStatusOption === LEAD_STATUS_LEASE_SIGNED
      && sortCriteria === APARTMENT_LOCATOR_LEADS_SORT_BY_MOVE_DATE
    ) {
      onUpdateSortCriteria(APARTMENT_LOCATOR_LEADS_SORT_BY_LEASE_START_DATE);
    }
    else if (
      newLeadStatusOption !== LEAD_STATUS_LEASE_SIGNED
      && sortCriteria === APARTMENT_LOCATOR_LEADS_SORT_BY_LEASE_START_DATE
    ) {
      onUpdateSortCriteria(APARTMENT_LOCATOR_LEADS_SORT_BY_MOVE_DATE);
    }
    dispatch(ApartmentLocatorActions.markAsReadLeadNotification, { leadStatus });
  };

  _onRefresh = () => {
    const { dispatch } = this.props;
    dispatch(ApartmentLocatorActions.resetLeadsTable);
  }

  render() {
    const { leadStatus, onSearchText, sortCriteria, leadsUpdated, onToggleSortCriteriaModal } = this.props;
    const newLeadsInStep = Object.keys(leadsUpdated).map(
      (renterUserId) => leadsUpdated[renterUserId].toLeadStatus
    );

    return (
      <div className='headerNavigation'>
        <div className='tabsContainer'>
          {LEAD_STATUS_LIST.map((leadStatusOption) => (
            <SrLink
              key={leadStatusOption}
              to={`/agent/leads/${leadStatusOption}`}
              onClick={() => this._onClick({ newLeadStatusOption: leadStatusOption })}
              className={classnames(
                leadStatusOption,
                {
                  newLeads: newLeadsInStep.includes(leadStatusOption) && leadStatusOption !== leadStatus,
                  active: leadStatusOption === leadStatus,
                }
              )}
            >
              {getLeadStatusLabel({ leadStatus: leadStatusOption })}
            </SrLink>
          ))}
        </div>
        <div className='titleContainer'>
          <span className='headlineContainer'>
            <H1>{getLeadStatusLabel({ leadStatus })}</H1>
            <span className='refresh' onClick={this._onRefresh}>Refresh</span>
          </span>
          <Formik
            enableReinitialize
            initialValues={{ searchText: '' }}
            render={(formikBag) => {
              return (
                <div className='addressSearchInputContainer'>
                  <SrFormikField
                    formField={{
                      id: 'searchText',
                      type: 'short_text',
                      properties: {
                        placeholder: 'Search name, phone, or notes',
                        className: 'addressSearchInput',
                        onChange: (event) => {
                          let searchText = event.target.value;
                          if (
                            searchText
                            && !!extractPhoneFromText(searchText)
                          ) {
                            searchText = extractPhoneFromText(searchText);
                          }
                          formikBag.setFieldValue('searchText', searchText);
                          onSearchText(searchText);
                        },
                      },
                    }}
                    formikBag={formikBag}
                  />
                  <div
                    onClick={onToggleSortCriteriaModal}
                    className={classnames('sortList', {
                      active: leadStatus === LEAD_STATUS_LEASE_SIGNED
                        ? sortCriteria === APARTMENT_LOCATOR_LEADS_SORT_BY_LEASE_START_DATE
                        : sortCriteria === APARTMENT_LOCATOR_LEADS_SORT_BY_MOVE_DATE,
                    })}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>
    );
  }
}

SrAgentLeadsHeader.displayName = 'SrAgentLeadsHeader';

export default SrAgentLeadsHeader;
